import { USER_FAVORITE_ADD_PATH, USER_FAVORITE_DEL_PATH } from '../paths';
import { FAVORITE_USER_PATH_SERVICES } from 'api/services/content/paths';
import { HttpClient } from 'api/helpers/HttpClient';

export const deleteFavContentService = async (params = {}) => {
  const { claroLiteConfig, ...restParams } = params;
  restParams.api_version = claroLiteConfig ?  null : 'v5.93';
  const apiCall = new HttpClient({ hasClaroAdActive: claroLiteConfig });
  return await apiCall.get(claroLiteConfig ? USER_FAVORITE_DEL_PATH : '/services/user/favoritedel', restParams);
};

export const addFavContentService = async (params = {}) => {
  const { claroLiteConfig, ...restParams } = params;
  restParams.api_version = claroLiteConfig ?  null : 'v5.93';
  const apiCall = new HttpClient({ hasClaroAdActive: claroLiteConfig });
  return await apiCall.get(claroLiteConfig ? USER_FAVORITE_ADD_PATH : '/services/user/favoriteadd', restParams);
};

export const getFavoriteContentService = async (params = {}) => {
  const { claroLiteConfig, ...restParams } = params;
  restParams.api_version = claroLiteConfig ?  null : 'v5.93';
  const apiCall = new HttpClient({ hasClaroAdActive: claroLiteConfig });
  return await apiCall.get(claroLiteConfig ? FAVORITE_USER_PATH_SERVICES : '/services/user/favorited', restParams);
};
